var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbVosaltres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "translate(0,84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 128,128 C 57.5,128 0,185.5 0,256 c 0,70.6 57.4,128 128,128 53.6,0 86.3,-29.4 111.4,-65.7 -7.5,-12.1 -13.8,-24 -20,-35.4 -22.4,37.1 -47.6,64.6 -91.4,64.6 -50.4,0 -91.4,-41 -91.4,-91.4 0,-50.7 40.7,-91.4 91.4,-91.4 29.6,0 48.4,10.6 65.7,28.6 17.3,18 32,44 46.9,71.4 14.9,27.4 29.9,56.3 52,79.4 22.1,23.1 52.5,40 91.4,40 70.5,0 128,-57.5 128,-128 0,-70.6 -57.4,-128 -128,-128 -53.3,0 -86.2,28.5 -111.4,64 7.5,11.9 14.4,23.5 20.6,34.9 22.3,-36 47.1,-62.3 90.9,-62.3 50.4,0 91.4,41 91.4,91.4 0,50.7 -40.7,91.4 -91.4,91.4 -29.1,0 -47.4,-10.6 -64.6,-28.6 -17.2,-18 -31.9,-44 -46.9,-71.4 C 257.6,220 242.3,191.1 220,168 197.7,144.9 167.3,128 128,128 Z",
    style: {
      fill: "#6E6259"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6E6259",
      fillRule: "evenodd"
    },
    id: "path33",
    cx: 124.62771,
    cy: 116.41695,
    r: 56.595646
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6E6259",
      fillRule: "evenodd"
    },
    id: "path33-1",
    cx: 380.62772,
    cy: 116.12372,
    r: 56.595646
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbVosaltres);
export default __webpack_public_path__ + "static/media/amb-vosaltres.f7d88d7e.svg";
export { ForwardRef as ReactComponent };